import { PocListItem } from 'commons/components/components-wrapper/poc-list-item.component';
import { AlarmBadgeTypes, AlarmsBadgeComponent } from 'commons-app/components';
import { PopoverMenuComponent, TooltipedTextComponent } from 'commons/components';
import { SideMenuAlarm } from 'core/service/user-preferences/domain';
import { useTranslation } from 'core/i18n';
import { UserCustomFilter } from 'core/utils/types/user-custom-filter.type';
import { useAppMenuHandle } from '../use-app-menu-handle.hook';
import { SideMenuListItem } from '../app.menu.style';

interface MenuFilterItemProps<T> {
    filter: UserCustomFilter<T>;
    module: string;
    showBadge?: boolean;
    sideMenuAlarms: Record<string, SideMenuAlarm>;
}

export const MenuFilterItem = <T,>({
    filter,
    module,
    showBadge = true,
    sideMenuAlarms,
}: MenuFilterItemProps<T>): React.ReactNode => {
    const { t } = useTranslation();
    const { handleShowConfirmDeleteFilterModal, handleShowRenameFilterModal } = useAppMenuHandle();

    return (
        <SideMenuListItem
            value={`${module.toLocaleLowerCase()}/filters/${filter.id}`}
            data-testid={`${module.toLocaleLowerCase()}-filters-${filter.id}`}
            key={filter.id}
            size="medium"
        >
            <TooltipedTextComponent
                i18nKey="<tooltip>{{name}}</tooltip>"
                tooltipText={filter.name}
                i18nValues={{ name: `${filter.name}` }}
            />

            <div slot="suffix">
                <AlarmsBadgeComponent
                    showBadge={showBadge}
                    alarms={sideMenuAlarms[filter.id!]}
                    size="medium"
                    type={module as AlarmBadgeTypes}
                />
                <div className="menu-button-options">
                    <PopoverMenuComponent anchor={`submenu-operators-${filter.id}`} position="bottom">
                        <PocListItem
                            variant="default"
                            value="rename"
                            size="medium"
                            onClick={() => handleShowRenameFilterModal(filter)}
                        >
                            {t('app.sidemenu.options.generic.submenu.popover.rename.filter.item')}
                        </PocListItem>
                        <PocListItem
                            variant="default"
                            value="delete"
                            size="medium"
                            onClick={() => handleShowConfirmDeleteFilterModal(filter)}
                        >
                            {t('app.sidemenu.options.generic.submenu.popover.delete.filter.item')}
                        </PocListItem>
                    </PopoverMenuComponent>
                </div>
            </div>
        </SideMenuListItem>
    );
};
